import Vue from 'vue'
import request from '@/utils/request'

// 验证token
export function verifyToken (token) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/verifyToken',
    method: 'get',
    params: {
      token: token
    }
  })
}

// 登录
export function login (loginname, password) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/safety/login',
    method: 'post',
    data: {
      loginname: loginname,
      password: password
    }
  })
}

// 微信登录
export function wxlogin (openId) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/auth/wxlogin',
    method: 'post',
    data: {
      code: '123',
      needCode: 0,
      openId: openId
    }
  })
}

// 绑定手机号
export function phoneBind (openId, phone) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/auth/wxPhoneBind',
    method: 'post',
    data: {
      openId: openId,
      encryptedData: '',
      iv: '',
      getType: 2,
      phone: phone
    }
  })
}

// 获取公司列表
export function getCompanyList () {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/huidi/getCompanyList',
    method: 'get'
  })
}

// 根据公司获取站点
export function getStationListByCompany (companyId) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/huidi/getStationListByCompany',
    method: 'get',
    params: {
      companyId
    }
  })
}

// 根据userid获取站点
export function getStationListByUserId (userId) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/app/${userId}`,
    method: 'get'
  })
}

// 根据手机号获取站点
export function getStationListByPhone (phone) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/station/${phone}`,
    method: 'get'
  })
}

// 获取聊天信息
export function chatgpt (data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/huidi/chatTongYi`,
    method: 'post',
    data: data
  })
}

// 根据userid获取用户信息
export function getUserInfoByUserId (userId) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/getUserInfoByUserId/${userId}`,
    method: 'get'
  })
}

// 修改用户信息
export function patchUserInfo (userId, data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/user/${userId}`,
    method: 'patch',
    data: {
      name: data.name,
      company: data.company,
      position: data.position,
      sex: data.sex,
      age: data.age
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/basic.js